module.exports = __webpack_public_path__ + "media/images/tiedye/versatile-5f16a00653da794b6447ecbf7fa5bbb3.png";